<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;padding-left:1.2rem;">修改登录密码</v-toolbar-title>
    </v-app-bar>
    <v-content>
        <v-container>
            <div style="width:95%;margin:auto;padding-top:1rem;">
              <v-form ref="form" lazy-validation>
                <v-text-field
                v-model="old_pass"
                label="旧密码"
                required
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1" />
                <v-text-field
                v-model="pass1"
                label="新密码"
                required
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                @click:append="show2 = !show2" />
                <v-text-field
                v-model="pass2"
                label="确认新密码"
                required
                :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show3 ? 'text' : 'password'"
                @click:append="show3 = !show3" />
              </v-form>
              <div style="text-align:center;margin-top:1.5rem;">
                  <v-btn style="width:80%;" color="primary" @click="changePass" large>确定修改</v-btn>
              </div>
            </div>
        </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  components: { },
  props: {
  },
  data() {
    return {
      old_pass: '',
      pass1: '',
      pass2: '',
      show1: false,
      show2: false,
      show3: false
    }
  },
  computed: {
  },
  mounted() {
    // var that = this
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    async changePass() {
      var that = this
      if (that.old_pass === '') {
        that.$toast.warning('请输入旧密码')
        return
      }
      if (that.pass1 === '') {
        that.$toast.warning('请输入新密码')
        return
      }
      if (that.pass2 === '') {
        that.$toast.warning('请输入确认新密码')
        return
      }
      if (!(/^(\d|[a-zA-Z])+$/.test(that.old_pass))) {
        that.$toast.warning('密码只能输入字母和数字')
        return
      }
      if (!(/^(\d|[a-zA-Z])+$/.test(that.pass1))) {
        that.$toast.warning('密码只能输入字母和数字')
        return
      }

      if (that.pass1 !== that.pass2) {
        that.$toast.warning('新密码不一致')
        return
      }
      var res = await that.$api.bz.changeLoginPass({ old_pass: that.old_pass, pass1: that.pass1, pass2: that.pass2 });
      // console.log('changeLoginPass.res', res);
      if (!res.success) {
        if (res.error_msg === '修改失败，旧密码错误.') {
          that.$toast.warning(res.error_msg)
          return
        }
        that.$router.goActionResPage({ tag: 0, text: '修改失败', auto_ret: 'y', dest: -2 })
        return
      }
      that.$router.goActionResPage({ tag: 1, text: '修改成功', auto_ret: 'y', dest: -2 })
    }
  }
}
</script>

<style scoped>
</style>

